const initialState = {
  commandes: [],
  commande: null,
  commandeLoading: false,
  commandeRefetchLoading: false,
  commandeError: null,
  commandesCount: 0,
  factureLoading: null,
  avoirLoading: null,
  currentComments: [],
  currentCommentsLoading: false,
  commentsLoading: false,
  payLoading: false,
  sendMailLoading: false,
  updateOrderPaysLoading: false,
};
const commandeReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "COMMANDES_LOADING":
      return { ...state, commandeLoading: true, commandeError: null };
    case "UPDATE_COMMANDE_PAY_LOADING":
      return {
        ...state,
        commandeLoading: true,
        commandeError: null,
        updateOrderPaysLoading: true,
      };
    case "UPDATE_COMMANDE_PAY_SUCC":
      return {
        ...state,
        commandeLoading: false,
        commandeError: null,
        updateOrderPaysLoading: false,
      };
    case "GENERATE_FACTURE_LOADING":
      return { ...state, factureLoading: payload };
    case "GENERATE_BON_LOADING":
      return { ...state, factureLoading: payload };
    case "GENERATE_AVOIR":
      return { ...state, avoirLoading: payload };
    case "GENERATE_FACTURE_SUCC":
    case "GENERATE_FACTURE_ERR":
      return { ...state, factureLoading: null };
    case "COMMANDES_REFETCH_LOADING":
      return { ...state, commandeRefetchLoading: true, commandeError: null };
    case "COMMANDES_SUCCESS":
      return {
        ...state,
        factureLoading: null,
        commandeLoading: false,
        commandeError: null,
        commandes: payload.commandes,
        commandesCount: payload.count,
        commandeRefetchLoading: false,
      };

    case "COMMANDE_SUCCESS":
      return {
        ...state,
        factureLoading: null,
        commandeLoading: false,
        commandeError: null,
        commande: payload.commande,
        commandeRefetchLoading: false,
      };

    case "UPDATE_COMMANDE":
      return {
        ...state,
        factureLoading: null,
        commandeLoading: false,
        commandeError: null,
        commandes: state.commandes.map((el) =>
          el.id === payload?.commandeId ? payload?.data : el
        ),
      };
    case "DELETE_COMMANDE":
      return {
        ...state,
        factureLoading: null,
        commandeLoading: false,
        commandeError: null,
        commandes: state.commandes.filter((el) => el.id !== payload),
      };
    case "COMMANDES_SUCCESS_REFETCH":
      return {
        ...state,
        commandeLoading: false,
        commandeError: null,
        commandeRefetchLoading: false,
        factureLoading: null,
        commandes: [...state.commandes, ...payload],
      };
    case "COMMANDES_ERROR":
      return {
        ...state,
        factureLoading: null,
        commandeLoading: null,
        commandeRefetchLoading: false,
        commandeError: null,
      };

    case "CREATE_COMMENTS_ORDER_LOADING":
      return { ...state, currentCommentsLoading: true };
    case "CREATE_COMMENTS_ORDER_SUCCESS":
      return {
        ...state,
        currentCommentsLoading: false,
        currentComments: [payload, ...state.currentComments],
      };

    case "FETCH_COMMENTS_ORDER_LOADING":
      return { ...state, commentsLoading: true };

    case "RESET_COMMANDES":
      return {
        ...state,
        factureLoading: null,
        commandeLoading: false,
        commandeError: null,
        commandes: [],
        commandesCount: 0,
        commandeRefetchLoading: false,
      };

    case "UPDATE_ORDER_COMMENT_SUCCESS": {
      const updatedComments = state.currentComments.map((comment) => {
        if (+comment?.id === +payload?.id) {
          return payload;
        }
        return comment;
      });
      return {
        ...state,
        currentComments: updatedComments,
        commentsLoading: false,
      };
    }
    case "DELETE_ORDER_COMMENT_SUCCESS": {
      const updatedComments = state.currentComments.filter((comment) => {
        return +comment?.id !== +payload;
      });
      return {
        ...state,
        currentComments: updatedComments,
        commentsLoading: false,
      };
    }
    case "FETCH_COMMENTS_ORDER_SUCCESS":
      return { ...state, currentComments: payload, commentsLoading: false };
    case "PAY_ORDER_LOADING":
      return { ...state, payLoading: true };
    case "PAY_ORDER_SUCC":
    case "PAY_ORDER_FAIL":
      return { ...state, payLoading: false };
    case "SEND_MAIL_LOADING":
      return { ...state, sendMailLoading: true };
    case "SEND_MAIL_SUCCESS":
      return { ...state, sendMailLoading: false };
    default:
      return state;
  }
};
export default commandeReducer;
